<div [innerHTML]="htmlContent"
     class="w-full flex justify-center video-wrapper-{{UUID}}">
</div>
